import { render } from "./ResultsMobile.vue?vue&type=template&id=146b6de8&scoped=true"
import script from "./ResultsMobile.vue?vue&type=script&lang=js"
export * from "./ResultsMobile.vue?vue&type=script&lang=js"

import "./ResultsMobile.vue?vue&type=style&index=0&id=146b6de8&lang=scss"
import "./ResultsMobile.vue?vue&type=style&index=1&id=146b6de8&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src2524174443/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146b6de8"]])

export default __exports__